export default __webpack_public_path__ + "static/media/icon_feed.135ac50d.svg";